import { render, staticRenderFns } from "./MortgageCaseBankDetails.vue?vue&type=template&id=04c1fd4d"
import script from "./MortgageCaseBankDetails.vue?vue&type=script&lang=js"
export * from "./MortgageCaseBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports